var FontAlignments = /*#__PURE__*/ function(FontAlignments) {
    FontAlignments["Center"] = "center";
    FontAlignments["Left"] = "left";
    FontAlignments["Right"] = "right";
    return FontAlignments;
}({});
var FontColors = /*#__PURE__*/ function(FontColors) {
    FontColors["Default"] = "default";
    FontColors["Primary"] = "primary";
    FontColors["Warning"] = "warning";
    return FontColors;
}({});
var FontDecorations = /*#__PURE__*/ function(FontDecorations) {
    FontDecorations["Dotted"] = "dotted";
    FontDecorations["None"] = "none";
    FontDecorations["Underline"] = "underline";
    return FontDecorations;
}({});
var FontSizes = /*#__PURE__*/ function(FontSizes) {
    FontSizes["Large"] = "large";
    FontSizes["Medium"] = "medium";
    FontSizes["Small"] = "small";
    FontSizes["XLarge"] = "xlarge";
    FontSizes["XSmall"] = "xsmall";
    FontSizes["XxLarge"] = "xxlarge";
    FontSizes["XxSmall"] = "xxsmall";
    return FontSizes;
}({});
var FontTransforms = /*#__PURE__*/ function(FontTransforms) {
    FontTransforms["Capitalize"] = "capitalize";
    FontTransforms["Lowercase"] = "lowercase";
    FontTransforms["None"] = "none";
    FontTransforms["Uppercase"] = "uppercase";
    return FontTransforms;
}({});
var FontWeights = /*#__PURE__*/ function(FontWeights) {
    FontWeights["Bold"] = "bold";
    FontWeights["Book"] = "book";
    FontWeights["Medium"] = "medium";
    return FontWeights;
}({});

export { FontAlignments, FontColors, FontDecorations, FontSizes, FontTransforms, FontWeights };
//# sourceMappingURL=fonts.js.map
